import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { SSL_TLS_CONFIGURATION, SSL_TLS_OVERVIEW } from "./sslTlsPaths";

/** Back-compat for /v2/certs and ?tab=configuration|overview */
export default function LegacyCertsRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  const siteUid = params.get("site_uid");

  if (tab === "configuration") {
    const qs = siteUid ? `?site_uid=${encodeURIComponent(siteUid)}` : "";
    return <Navigate to={`${SSL_TLS_CONFIGURATION}${qs}`} replace />;
  }

  return <Navigate to={SSL_TLS_OVERVIEW} replace />;
}
